<template>
  <el-dialog :title="title" :visible.sync="visiable" :close-on-click-modal="false" width="50%" @close="onClose()">
    <el-form :model="replyInfo" :rules="rules" ref="replyInfo" label-width="100px" class="messageTip">
      <!-- 只读 -->
      <div class="lx-flex-row">
        <el-form-item label="用户ID:">
          <span>{{ userName }}</span>
        </el-form-item>
        <el-form-item label="消息类型:">
          <span>{{ messageType }}</span>
        </el-form-item>
        <el-form-item v-if="orderNo" label="订单编号:">
          <span>{{ orderNo }}</span>
        </el-form-item>
      </div>
      <el-form-item label="模板:">
        <el-select v-model="replyInfo.remindingTitleJa" placeholder="请选择" @change="onChange">
          <el-option v-for="item in messageList" :key="item.id" :value="item.remindingTitle" :label="item.remindingTitle">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 内容 -->
      <el-form-item label="标题:" prop="remindingTitle">
        <el-input v-model="replyInfo.remindingTitle"></el-input>
      </el-form-item>
      <el-form-item label="内容:" prop="remindingContent">
        <!-- <el-input v-model="replyInfo.remindingContent" type="textarea" :autosize='{minRows: 4}'></el-input> -->
        <quill-editor ref="text" v-model="replyInfo.remindingContent" :options="editorOption" />
      </el-form-item>
      <el-form-item label="跳转链接:" prop="url">
        <el-input v-model="replyInfo.url"></el-input>
      </el-form-item>
      <!-- 上传图片 -->
      <el-form-item label="图片:">
        <el-upload class="editor-slide-upload" action="https://oytqc-oss.oss-cn-qingdao.aliyuncs.com" :data="imgDataObj"
                   list-type="picture-card" :file-list="imgFileList" :show-file-list="true" :on-remove="handleImgRemove"
                   :on-success="handleImgSuccess" :before-upload="beforeImgUpload" :limit="limit" :multiple="true" :on-exceed="handleExceed"	>
          <el-button size="small" type="primary">点击上传</el-button>
          <div ref="preview" @paste="handlePaste" class="paste-img"></div>
        </el-upload>
      </el-form-item>

      <!-- 上传附件 -->
      <el-form-item label="上传附件">
        <el-upload class="editor-slide-upload" action="" :on-preview="handlePreview" :on-remove="handleRemove"
          :before-upload="beforeUploadFile" :before-remove="beforeRemove" :on-success="handleOrderInfo" :show-file-list="true"
          :on-exceed="handleExceed" :file-list="attachmentList" :http-request="excelUploadRequest" :limit="limit" :multiple="true">
          <el-button class="search-btn btn-blue">上传附件</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <div style="text-align:right;">
      <el-button class="form-btn btn-gray" @click="onClose">取 消</el-button>
      <el-button class="form-btn btn-blue" @click="replySave('replyInfo')">提 交</el-button>
    </div>
  </el-dialog>
</template>
<script>
import Oss from "../../assets/js/oss.js";
const toolbarOptions = [
  ['bold'], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
]
export default {
  name: "MessageTip",
  props: {
    title: {
      type: String,
      default: '提醒'
    },
    visiable: {
      type: Boolean,
      default: false
    },
    id: {
      type: String || Number,
      default: ''
    },
    userName: {
      type: String,
      default: ''
    }, // 用户id
    messageType: {
      type: String,
      default: '其他消息'
    }, // 消息类型
    orderNo: {
      type: String || Number,
      default: ''
    }, // 订单编号
    httpUrl: {
      type: String,
      default: ''
    }, // 请求地址
    limit:{
      type: Number,
      default: 3
    }
  },
  data () {
    return {
      messageList: [],
      replyInfo: {
        id: '',
        orderId: '',
        remindingUserName: '',
        remindingTitle: '',
        remindingTitleJa: '',
        remindingContent: '',
        url: '',
        replyPicture: '',
        attachment:''
      },
      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions,
          }
        }
      },
      imgDataObj: {
        policy: '',
        signature: '',
        key: '',
        ossaccessKeyId: '',
        dir: '',
        host: '',
        timeStamp: ''
      },
      rules: {
        remindingTitleJa: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        remindingContent: [
          { required: true, message: '请输入回复内容', trigger: 'blur' }
        ]
      },
      attachmentList: [],
      imgFileList:[],
      listObj: {},
    };
  },
  watch: {
    visiable (val) {
      if (val) {
        this.attachmentList = []
        this.imgFileList = []
        this.doReset().then(() => {
          this.getMessageList()
        })
      }
    }
  },
  methods: {

    // 获取复制图片处理
    async handlePaste(event) {
      const files = (event.clipboardData || window.clipboardData).files;
      if (!files || files.length === 0) {
        this.$message.error("当前浏览器不支持本地");
        return;
      }
      // 搜索剪切板items
      for (const file of files) {
        if (file) {
          if (file.type.indexOf("image") === -1){
            return this.$message.error("粘贴内容非图片");
          }
          let formdata = new FormData();
          formdata.append('file', file);
          // 数据保存
          const {data: res} = await this.$http.post('cmUser/message/uploadFile', formdata);
          if (res.code === 200) {
            this.imgFileList.push({
              name: res.data.fileName,
              url: res.data.filePath
            })
          }
        }
      }
    },
    onChange (val) {
      const obj = this.messageList.find(item => item.remindingTitle === val)
      this.replyInfo.remindingTitle = obj.remindingTitleJa
      this.replyInfo.remindingContent = obj.remindingContentJa
      this.replyInfo.url = obj.url
    },
    getMessageList () {
      this.$http.get('template/message/getList').then(res => {
        this.messageList = res.data.data
      })
    },
    replySave (formName) {    //提醒弹窗保存按钮
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addReply();
        } else {
          this.$message.error('必填项不能为空，请重新填写并提交！');
          return false;
        }
      });
    },
    async addReply () {    //添加
      if (!this.handleImgSubmit()) {
        return false
      }
      this.replyInfo.orderId = this.orderNo
      this.replyInfo.remindingUserName = this.userName
      this.replyInfo.id = this.id
      const { data: res } = await this.$http.post(this.httpUrl, this.replyInfo);
      if (res.code == 200) {
        this.$message({
          type: 'success',
          message: res.message
        })
        this.$emit('confirm')
      } else {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
    },
    handleImgSubmit () {
      var _this = this;
      const arr = Object.keys(_this.listObj).map(v => _this.listObj[v]);
      if (!Oss.checkAllSuccess(_this.listObj)) {
        _this.$message('请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！')
        return false
      } else {
        if (arr.length > this.limit) {
          _this.$message.error(`最多可上传${this.limit}张图片`);
          return false
        }

        _this.imgFileList = _this.imgFileList.concat(arr);
        var urlArr = [];
        _this.imgFileList.forEach(el => {
          urlArr.push(el.url);
        })
        _this.replyInfo.replyPicture = urlArr.toString();
        //   _this.$emit('successCBK', arr);
        _this.listObj = {};
        //   _this.imgDialogVisible = false;
      }
      if (_this.attachmentList.length>0){
        _this.replyInfo.attachment = JSON.stringify(this.attachmentList);
      }else{
        _this.replyInfo.attachment = ''
      }
      return true
    },
    handleImgRemove (file, fileList) {
      this.imgFileList = fileList
      Oss.imgRemove(file, this.listObj);
    },
    handleImgSuccess (response, file) {
      Oss.imgSuccess(file, this.listObj, this.imgDataObj);
    },
    beforeImgUpload (file) {
      const _self = this;
      const fileName = file.uid;
      this.listObj[fileName] = {};
      return new Promise((resolve, reject) => {
        _self.$http.get('aliyun/oss/policy').then(response => {
          var num = "";   //定义编号
          for (var i = 0; i < 4; i++) //4位随机数，用以加在时间戳后面。
          {
            num += Math.floor(Math.random() * 10);
          }
          num = new Date().getTime() + num;  //时间戳，用来生成编号。
          _self.imgDataObj.policy = response.data.data.policy;
          _self.imgDataObj.signature = response.data.data.signature;
          _self.imgDataObj.ossaccessKeyId = response.data.data.accessKeyId;
          _self.imgDataObj.key = response.data.data.dir + '/order/' + num + '${filename}';
          _self.imgDataObj.dir = response.data.data.dir + '/order';
          _self.imgDataObj.host = response.data.data.host;
          _self.imgDataObj.timeStamp = num;
          Oss.imgCompress(file, this.listObj, resolve, reject)
        }).catch(err => {
          reject(true)
        })
      })
    },
    handlePreview () {
      // console.log(file);
    },
    handleRemove (file, fileList) {
      for (let i = 0; i < this.attachmentList.length; i++) {
        let attach = this.attachmentList[i];
        if (file.name == attach.name) {
          this.attachmentList.splice(i, 1)
        }
      }
    },
    beforeUploadFile (file) {
      const extension = file.name.substring(file.name.lastIndexOf('.'))
      // const size = file.size / 1024 / 1024
      if (extension !== '.xls' && extension !== '.xlsx' && extension !== '.pdf' && extension !== '.mp4') {
        this.$message.warning('只能上传excel和pdf文件')
        return false
      }
    },
    beforeRemove () {
      // return this.$confirm(`${this.$t('orderList.orderList107')} ${file.name}?`);
    },
    // 批量导入成功回调
    handleOrderInfo () {
      console.log('success')
      // console.log(data)
    },
    // 超过最大上传限度
    handleExceed (files, fileList) {
      this.$message.error(`最多可上传${this.limit}张图片或附件`);
    },
    async excelUploadRequest (file) {
      let formdata = new FormData();
      formdata.append('file', file.file);
      const { data: res } = await this.$http.post('cmUser/message/uploadFile', formdata);
      if (res.code === 200) {
        let {fileName,filePath} = res.data;
        this.attachmentList.push({name:fileName,url:filePath})
      }
    },
    onClose () {
      this.$emit('update:visiable', false)
    },
    doReset () {
      return new Promise(resolve => {
        this.replyInfo.remindingTitle = '',
        this.replyInfo.remindingTitleJa = '',
        this.replyInfo.remindingContent = '',
        this.replyInfo.url = '',
        this.replyInfo.replyPicture = '',
        this.replyInfo.attachment = '',
        this.attachmentList = []
        this.imgFileList = []
        this.listObj = {}
        resolve()
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .paste-img {
    position: absolute;
    top: 0;
    left: 1px;
    width: 1px;
    height: 1px;
    z-index: 999;
  }
.messageTip {
}
</style>
